'use strict';

import angular from 'angular';
import SetPasswordController from './setpassword.controller.js';

export default angular.module('georgeApp.setpassword', [])
  .controller('SetPasswordController', SetPasswordController)
  .name;
